import { render, staticRenderFns } from "./TherapistCreateDashComponent.vue?vue&type=template&id=758068f9&scoped=true"
import script from "./TherapistCreateDashComponent.vue?vue&type=script&lang=js"
export * from "./TherapistCreateDashComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758068f9",
  null
  
)

export default component.exports